import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079af71b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "p-mt-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_8 = { class: "confirmation-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PromotionalSMSDialog = _resolveComponent("PromotionalSMSDialog")!
  const _component_SMSPackageDialog = _resolveComponent("SMSPackageDialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Promotion Name"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search",
                class: "p-button-primary p-mr-1",
                onClick: _ctx.loadSearchData
              }, null, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              label: "SMS Packages",
              icon: "pi pi-eye",
              class: "p-button-info",
              onClick: _ctx.openSMSPackagesDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DataTable, {
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          firstModifiers: { sync: true },
          value: _ctx.lists,
          lazy: true,
          paginator: _ctx.checkPagination,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          scrollable: true,
          onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "promotion_name",
              header: "Promotion Name",
              class: "wrap-text"
            }),
            _createVNode(_component_Column, {
              field: "mask_type",
              header: "Mask",
              class: "wrap-text"
            }),
            _createVNode(_component_Column, {
              field: "status",
              header: "Delivery Status",
              class: "wrap-text"
            }),
            _createVNode(_component_Column, {
              field: "message",
              header: "Message",
              class: "wrap-text"
            }),
            _createVNode(_component_Column, {
              header: "Contact Numbers",
              class: "wrap-text"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.contacts.map(contact => contact.contact_number).join(', ')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.status === null)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Send",
                      icon: "pi pi-send",
                      class: "p-button-rounded p-button-info",
                      disabled: slotProps.data.sending,
                      onClick: ($event: any) => (_ctx.openPopupDialog(slotProps.data))
                    }, null, 8, ["disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Check Status",
                      icon: "pi pi-refresh",
                      class: "p-button-rounded p-button custom-green",
                      disabled: slotProps.data.status === 'completed',
                      onClick: ($event: any) => (_ctx.loadCampainStatus(slotProps.data))
                    }, null, 8, ["disabled", "onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.popupDialog,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.popupDialog) = $event)),
        style: { width: '450px' },
        header: "Notification"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "OK",
            icon: "pi pi-check",
            class: "p-button-primary",
            onClick: _ctx.popupDialogOkButton
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.popupDialogText), 1)
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_PromotionalSMSDialog, {
        promotionDetail: {
          status: _ctx.profileStatus,
          profilerID: _ctx.profilerID,
          statusType: _ctx.statusType,
          dialogTitle: _ctx.dialogTitle,
          currentUserID: _ctx.currentUserID,
          promotionId: _ctx.promotionId,
        },
        remainingSMSQuota: _ctx.totalRemainingSMS,
        onUpdatePromotionStatus: _ctx.updatePromotionStatus,
        onUpdatePackageData: _ctx.updatePackage
      }, null, 8, ["promotionDetail", "remainingSMSQuota", "onUpdatePromotionStatus", "onUpdatePackageData"]),
      _createVNode(_component_SMSPackageDialog, {
        visible: _ctx.smsPackagesDialogVisible,
        smsPackages: _ctx.smsPackages,
        totalSMSCount: _ctx.totalSMSCount,
        totalUsage: _ctx.totalUsage,
        totalRemainingSMS: _ctx.totalRemainingSMS,
        activePackagesCount: _ctx.activePackagesCount,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.smsPackagesDialogVisible = $event))
      }, null, 8, ["visible", "smsPackages", "totalSMSCount", "totalUsage", "totalRemainingSMS", "activePackagesCount"])
    ])
  ]))
}